import React, { useEffect } from 'react';
import { matchPath, useLocation, useSearchParams } from 'react-router-dom';
import { useAppDispatch } from '../../../store/hooks';
import { fetchReports } from '../../../actions/mine_craft/reportsActions';
import { queryParams } from "../../../helpers/UrlHelpers";
import minecraftUrls from "../../../configs/mine_craft/minecraftUrls";

import PageHeader from './_partials/_PageHeader';
import PageLayout from '../_partials/PageLayout';
import List from "./_partials/_List";

const LIMIT = 50;

const Reports: React.FC = () => {
  const dispatch        = useAppDispatch();
  const [searchParams]  = useSearchParams();
  const currentPage     = queryParams.getInt(searchParams,'page') || 1;
  const { pathname }    = useLocation();

  useEffect(() => {
    const params: any = {
      limit: LIMIT,
      offset: (currentPage - 1) * LIMIT
    };

    switch (true) {
      case !!matchPath(minecraftUrls.reportAddonsPath(), pathname):
        params.target_type = 'Addon';
        break;
      case !!matchPath(minecraftUrls.reportUsersPath(), pathname):
        params.target_type = 'User';
        break;
      case !!matchPath(minecraftUrls.reportCommentsPath(), pathname):
        params.target_type = 'Comment';
        break;
      default:
    }

    dispatch(fetchReports(params));
  }, [currentPage, pathname, dispatch]);

  return (
    <PageLayout>
      <PageHeader />

      <div className='v-container-fluid'>
        <List limit={LIMIT} />
      </div>
    </PageLayout>
  );
}

export default Reports;
